import { PropsWithChildren } from 'react'
import { Button, Label } from 'reactstrap'

interface FeatureFlagListContainerProps {
  title?: string
  nested?: boolean
  toggleAll?: () => void
}

export const FeatureFlagListContainer = ({
  title,
  nested,
  toggleAll,
  children,
}: PropsWithChildren<FeatureFlagListContainerProps>) => {
  return (
    <div className={nested ? 'ml-4' : ''}>
      <div className="d-flex justify-content-between">
        {title && <Label>{title}</Label>}
        {toggleAll && (
          <Button color="link" size="sm" onClick={toggleAll}>
            Select all
          </Button>
        )}
      </div>
      <div
        className="p-2 d-flex flex-column"
        style={{
          border: 'solid #dee2e6 1px',
          borderRadius: 4,
          maxHeight: 180,
          overflow: 'auto',
          gap: '0.5rem',
        }}>
        {children}
      </div>
    </div>
  )
}
